import ServiceLocator from "../../../../../domain/service-locator";
import { useCallback, useMemo } from "react";
import AnimatedPageTransition from "../../../../../domain/module/navigation/animated-page-transition";
import { useNavigationModule } from "@agp/shared.user-app/application/context/navigation";
import { useLanguageBasedFont } from "../../const/font-utils";

export const MonotoneNotePage = () => {
  const languageRepository = ServiceLocator.LanguageRepository;
  const localizedEntityRepository = ServiceLocator.LocalizedEntityRepository;

  const currentLanguageId = languageRepository.currentLanguageId.watch();
  const navigation = useNavigationModule();
  const fontClass = useLanguageBasedFont();
  const firstArea = localizedEntityRepository.entities.watch().areas[0];

  const currentLanguage = useMemo(
    () => languageRepository.languages.find((x) => x.id === currentLanguageId)!,
    [languageRepository, currentLanguageId]
  );

  const handleClickNext = useCallback(() => {
    navigation.push(
      "guides",
      {
        areaId: firstArea.id,
      },
      {
        pageOutType: "fade",
        pageInType: "fade",
      }
    );
  }, [firstArea.id, navigation]);

  return (
    <AnimatedPageTransition>
      <div
        className={`bg-white flex items-center justify-center p-4 ${fontClass}`}
        style={{ height: window.innerHeight }}
      >
        {currentLanguage.localeId === "ja-JP" ? (
          <div className="px-[40px] relative flex flex-col items-center justify-center gap-[60px] bg-[#F2F2F2] rounded-3xl max-w-md w-full h-[90%] max-h-[638px] p-8 text-center">
            <div className="absolute text-3xl [@media(min-height:400px)]:top-12 [@media(min-height:700px)]:top-24">
              お願い
            </div>
            <div className={"w-full text-left"}>
              音声をお聞きになる際には、 イヤホンを
              <br />
              ご使用ください。
            </div>
            <div className={"w-full text-left"}>
              展示室内では、ほかのお客様や展示作品
              <br />
              との間隔にご配慮ください。
            </div>
            <div className={"w-full text-left"}>
              写真撮影は個人利用に限り可能です。
            </div>
            <div className="absolute bottom-8 w-full flex items-center justify-between px-8">
              <div className="text-left flex items-center gap-2">
                <img
                  alt="noextone-logo"
                  src={"/lookback/nextone-logo.png"}
                  className={"w-12"}
                />
                <div className="text-sm">許諾番号：ID000011522</div>
              </div>
              <div
                onClick={handleClickNext}
                className="cursor-pointer w-20 h-20 rounded-full bg-gray-200 border-[1px] border-[#999999] flex items-center justify-center text-3xl"
              >
                次へ
              </div>
            </div>
          </div>
        ) : (
          <div className="px-[40px] relative flex flex-col items-center justify-center gap-[60px] bg-[#F2F2F2] rounded-3xl max-w-md w-full h-[90%] max-h-[638px] p-8 text-center">
            <div className="absolute text-3xl [@media(min-height:400px)]:top-12 [@media(min-height:700px)]:top-24">
              Request
            </div>
            <div className={"w-full text-left"}>
              Please use headphones when listening to the audio guide.
            </div>
            <div className={"w-full text-left"}>
              In the exhibition rooms, please maintain distance from other
              visitors and exhibits.
            </div>
            <div className={"w-full text-left"}>
              Photography is permitted for personal use only.
            </div>
            <div className={"absolute bottom-8 right-8"}>
              <div
                onClick={handleClickNext}
                className="cursor-pointer w-20 h-20 rounded-full bg-gray-200 border-[1px] border-[#999999] flex items-center justify-center text-2xl"
              >
                Next
              </div>
            </div>
          </div>
        )}
      </div>
    </AnimatedPageTransition>
  );
};
